/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import 'swiper/swiper-bundle.css';
import marquee from 'vanilla-marquee';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    // window.onload = function () {
    //   const header = document.querySelector('header');
    //   const firstSlide = document.querySelector('.full-slider .swiper-slide');
    //   if (firstSlide.classList.contains('slide-white-text')) {
    //       header.classList.add('header-white');
    //   } else {
    //       header.classList.add('header-black');
    //   }
    // };
    const fullSlider = new Swiper('.full-slider', {
      // .active-slide
      loop:true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".full-slide-next",
        prevEl: ".full-slide-prev",
      },
      pagination: {
        el: ".full-slide-mobile-navigation",
      },
      breakpoints: {
        0: {
          autoHeight: true,
        },
        992: {
          autoHeight: false,
        },
      },
      on: {
        slideChange: function () {
          document.querySelectorAll(".full-slide-thumb .thumb-slide").forEach(function(element) {
              element.classList.remove("thumb-active");
          });
    
          // Aktif slaydın bir sonraki indeksine karşılık gelen .thumb-slide öğesine active sınıfını ekle
          var activeThumbSlide = document.querySelectorAll(".full-slide-thumb .thumb-slide")[this.realIndex ];
          if (activeThumbSlide) {
              activeThumbSlide.classList.add("thumb-active");
          }
            // Aktif slayt değiştiğinde çalışacak kod
            var activeSlide = this.slides[this.realIndex + 1];
            var header = document.querySelector('header');
            var thSlide = document.querySelector('.full-slide-thumb');
            var thSlideArrow = document.querySelector('.full-slide-arrow');
            if (activeSlide.classList.contains('slide-white-text')) {
                // Eğer aktif slayt belirli bir sınıfa sahipse yapılacak işlemler
              header.classList.remove("header-black");
              header.classList.add("header-white");
              thSlide.classList.remove("slide-black");
              thSlide.classList.add("slide-white");
              thSlideArrow.classList.remove("slide-black");
              thSlideArrow.classList.add("slide-white");
                
            } else {
              header.classList.remove("header-white");
              header.classList.add("header-black");
              thSlide.classList.remove("slide-white");
              thSlide.classList.add("slide-black");
              thSlideArrow.classList.remove("slide-white");
              thSlideArrow.classList.add("slide-black");
            }
        },
        init: function () {
            var activeSlide = this.slides[this.realIndex + 1];
            var header = document.querySelector('header');
            var thSlide = document.querySelector('.full-slide-thumb');
            var thSlideArrow = document.querySelector('.full-slide-arrow');
            if (activeSlide.classList.contains('slide-white-text')) {
                // Eğer aktif slayt belirli bir sınıfa sahipse yapılacak işlemler
              // header.classList.remove("header-black");
              // header.classList.add("header-white");
              thSlide.classList.remove("slide-black");
              thSlide.classList.add("slide-white");
              thSlideArrow.classList.remove("slide-black");
              thSlideArrow.classList.add("slide-white");
                
            } else {
              // header.classList.remove("header-white");
              // header.classList.add("header-black");
              thSlide.classList.remove("slide-white");
              thSlide.classList.add("slide-black");
              thSlideArrow.classList.remove("slide-white");
              thSlideArrow.classList.add("slide-black");
            }
        },
      },
    });
    document.querySelectorAll(".full-slide-thumb .thumb-slide").forEach(function(thumbSlide) {
      thumbSlide.addEventListener("click", function() {
          document.querySelectorAll(".full-slide-thumb .thumb-slide").forEach(function(element) {
              element.classList.remove("thumb-active");
          });
          this.classList.add("thumb-active");
          var index = Array.prototype.indexOf.call(this.parentElement.children, this);
          fullSlider.slideTo(index+1);
      });
    });
    
  };

  const homeSlideCurrency = () => {
    if(document.getElementById('marquee-currency')){
      new marquee(document.getElementById('marquee-currency'), {
        gap: 0,
        delayBeforeStart: 100,
        direction: "left",
        duplicated: !0,
        startVisible: !0,
        pauseOnHover: !0,
        duration: window.innerWidth < 768 ? 7500 : 15000
      });
    }
  };

  const homeNewsSlider = () => {
    const homeNewsSlider = new Swiper('.news-list', {
      slidesPerView: 3,
      spaceBetween: 30,
      autoHeight:false,
      navigation: {
        nextEl: ".h-news-next",
        prevEl: ".h-news-prev",
      },
      pagination: {
        el: ".home-news-mobile-navigation",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        680: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      },
    });
  };

  const homeExchangeSlider = () => {
    const homeExchangeSlider = new Swiper('.cp-form-slide', {
      slidesPerView: 3,
      spaceBetween: 15,
      autoHeight:false,
      navigation: {
        nextEl: ".ex1-next",
        prevEl: ".ex1-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        680: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      },
      on: {
        init: function (swiper) {
          checkEx1Slides(swiper);
        },
        resize: function (swiper) {
          checkEx1Slides(swiper);
        },
      },
    });
    function checkEx1Slides(swiper) {
      const currentBreakpoint = swiper.currentBreakpoint;
      const slidesPerView = swiper.params.breakpoints[currentBreakpoint].slidesPerView || swiper.params.slidesPerView;
      const totalSlides = swiper.slides.length;
      const arrows = document.querySelectorAll('.exchange-arrow-fs');

      arrows.forEach(arrow => {
        if (totalSlides < slidesPerView) {
          arrow.classList.add('hide');
        } else {
          arrow.classList.remove('hide');
        }
      });
    }
  };

  const hkScrollSlider = () => {
    if($(".category-scroll-container").is(":visible")){
      const swiperNews = new Swiper('.category-scroll-container', {
        slidesPerView: 5,
        spaceBetween: 0,
        watchSlidesProgress:true,
        // centeredSlides:true,
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // navigation: {
        //   nextEl: ".sp-n-next",
        //   prevEl: ".sp-n-prev",
        // },
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 0,
            centeredSlides: true,
            allowTouchMove: true,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
            centeredSlides: true,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 0,
            centeredSlides: false,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
        },
        on: {
            transitionEnd: function() {
              var activeIndex = this.activeIndex;
              $(".category-scroll-container .scroll-item").eq(activeIndex).find("a").trigger("click");
                // window.scrollTo({
                //   top: $($(".category-scroll-container .scroll-item").eq(activeIndex).find("a").attr("href")).offset().top,
                //   behavior: 'smooth'
                // });
            },
            init: function() {
              checkNavigationVisibility(this);
            },
            resize: function() {
              checkNavigationVisibility(this);
            },
        }
      });
      function checkNavigationVisibility(swiper) {
        const totalSlides = swiper.slides.length;
        const slidesPerView = swiper.params.slidesPerView;
        
        if (totalSlides > slidesPerView) {
          document.querySelector('.sp-n-prev').style.display = 'flex';
          document.querySelector('.sp-n-next').style.display = 'flex';
        } else {
          document.querySelector('.sp-n-prev').style.display = 'none';
          document.querySelector('.sp-n-next').style.display = 'none';
        }
      }
      if (window.innerWidth < 992) {
        document.querySelectorAll('.category-scroll-container .scroll-item a').forEach((link, index) => {
          link.addEventListener('click', (event) => {
            event.preventDefault(); // Varsayılan tıklama davranışını engelle
            swiperNews.slideTo(index); // İlgili indekse kaydır
          });
        });
        // window.addEventListener('load', () => {
        //   const hash = window.location.hash.substring(1); 
        //   if (hash) {
        //     const targetLink = Array.from(document.querySelectorAll('.category-scroll-container .scroll-item a')).find(link => link.href.includes(`#${hash}`));
        //     if (targetLink) {
        //       // İlgili a etiketine tıklat
        //       targetLink.click();
        //     }
        //   }
        // });
      }
      $(".category-scroll-arrow .sp-n-next").on("click", function(){
        swiperNews.slideNext();
        setTimeout(function(){
          window.scrollTo({
              top: $($(".category-scroll-container .scroll-item.swiper-slide-active").find("a").attr("href")).offset().top + 1,
              behavior: 'smooth'
            });
        }, 500);
      });
      $(".category-scroll-arrow .sp-n-prev").on("click", function(){
        swiperNews.slidePrev();
        setTimeout(function(){
          window.scrollTo({
              top: $($(".category-scroll-container .scroll-item.swiper-slide-active").find("a").attr("href")).offset().top + 1,
              behavior: 'smooth'
            });
        }, 500);
      });
      $(document).ready(function() {
        checkAndInitScrolling();
      
        $(window).on('resize', function() {
          checkAndInitScrolling();
        });
      });
      
      function checkAndInitScrolling() {
        if ($(".category-scroll-container .scroll-item").is(":visible")) {
          scrollingPg();
        }
      }
      
      function scrollingPg() {
        $(window).off('scroll');
        $(window).on('scroll', function() {
          var scroll = $(window).scrollTop();
          var anchorItem = $(".category-scroll-container .scroll-item");
      
          $(".participation-list.scroll-list").each(function() {
            var scrollItem = $(this);
            var scrollOffset = scrollItem.offset().top;
      
            if (scroll >= scrollOffset) {
              scrollItem.addClass("active");
              swiperNews.slideTo(scrollItem.index());
              anchorItem.removeClass("swiper-slide-active");
              anchorItem.eq(scrollItem.index()).addClass("swiper-slide-active");
            } else {
              scrollItem.removeClass("active");
              anchorItem.eq(scrollItem.index()).removeClass("swiper-slide-active");
            }
          });
      
          if (scroll <= $(".participation-list.scroll-list").eq(0).offset().top) {
            anchorItem.eq(0).addClass("swiper-slide-active");
          }
        });
      }
    }
    function smoothScroll(target) {
      const element = document.getElementById(target);
      if (element) {
        window.scrollTo({
          top: element.offsetTop + 1,
          behavior: 'smooth'
        });
      }
    }
    document.addEventListener('DOMContentLoaded', function() {
      const anchors = document.querySelectorAll('a[href^="#"]');
      anchors.forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
          event.preventDefault();
          const target = anchor.getAttribute('href').substring(1);
          smoothScroll(target);
        });
      });
    });
  }

  const milestonesSlider = () => {

    const milestonesThumbSlider = new Swiper('.milestones-slide-thumb', {
      slidesPerView: 1,
      spaceBetween: 0,
      watchSlidesProgress:true,
      on: {
        slideChange:function(){
          let slideCurrentIndex = this.realIndex;
          milestonesSlider.slideTo(this.realIndex);
        }
      }
    });

    const milestonesSlider = new Swiper('.milestones-slide', {
      slidesPerView: 6,
      spaceBetween: 0,
      // centeredSlides:true,
      // allowTouchMove: false,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: ".ml-n-next",
        prevEl: ".ml-n-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 0,
        },
      },
      thumbs: {
        swiper: milestonesThumbSlider,
      },
      on: {
        snapGridLengthChange:function(){
          if( this.snapGrid.length != this.slidesGrid.length ){
            this.snapGrid = this.slidesGrid.slice(0);
          }
        }
      }
    });
    
  };

  const blogSlider = () => {

    const blogSlider = new Swiper('.blog-slide', {
      slidesPerView: 1,
      spaceBetween: 0,
      // centeredSlides:true,
      // allowTouchMove: false,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: ".blog-slide-next",
        prevEl: ".blog-slide-prev",
      }
    });
    
  };

  const init = () => {
    fullSlider();
    homeSlideCurrency();
    homeNewsSlider();
    homeExchangeSlider();
    hkScrollSlider();
    milestonesSlider();
    blogSlider();
  };

  return {
    init,
  };
})();

export default slider;
